import DeviceScreen from 'lib/DeviceScreen';

export interface DeviceScreen {
  isMobile?: boolean;
  isTablet: boolean;
}

// TODO: Make this update when the browser window changes
export default function useDeviceScreen(): DeviceScreen {
  return {
    isMobile: DeviceScreen.isMobile(),
    isTablet: DeviceScreen.isTablet(),
  };
}
